module.exports = __webpack_public_path__ + "static/grummies-are-a-frood-group-507b6072c629f22942e8fd6a2d36c584.svg";